export default "__VITE_ASSET__DZcyMTYj__"